import {
  IExistingRules,
  IRawDataObject,
  IRulePipelineStatus,
} from "../../util/interface"
import { TableRowData as TableRowDataInterface } from "./OverView"

export const existingRules: any = [
  "DAY' column need to be not null",
  "DAY' multicolumn values to be unique",
]

export const sampleData: TableRowDataInterface[] = [
  {
    id: 1,
    qualityType: "Data Quality",
    qualityRulesEnabled:
      "Ensure that no special characters are present in 'Product Description' column.",
    pepelineImplementationStatus: "Completed",
    ruleRunProgress: 100,
    new: true,
    addedToPipeline: false,
  },
  {
    id: 2,
    qualityType: "Data Quality",
    qualityRulesEnabled:
      "Ensure that Discount Percentage is between 0 and 100.",
    pepelineImplementationStatus: "In Progress",
    ruleRunProgress: 10,
    new: false,
    addedToPipeline: false,
  },
  {
    id: 3,
    qualityType: "Business Quality",
    qualityRulesEnabled:
      "Ensure missing values are filled with nearest certainty.",
    pepelineImplementationStatus: "In Progress",
    ruleRunProgress: 15,
    new: false,
    addedToPipeline: false,
  },
  {
    id: 4,
    qualityType: "Business Quality",
    qualityRulesEnabled:
      "Ensure SKU sales value meets 90% historical conformity.",
    pepelineImplementationStatus: "Completed",
    ruleRunProgress: 10,
    new: true,
    addedToPipeline: false,
  },
  {
    id: 5,
    qualityType: "Data Quality",
    qualityRulesEnabled:
      "Ensure 'Sales Volume' and 'Sales value' are non-negative.",
    pepelineImplementationStatus: "Not Started",
    ruleRunProgress: 20,
    new: false,
    addedToPipeline: false,
  },
]
export const sampleGenAiRules: any[] = [
  {
    "Rule Title":
      "Ensure no missing values in critical fields like 'Product ID', 'Sales Date', 'Sales Volume', 'Sales Value'.",
    Description:
      "Ensure no missing values in critical fields like 'Product ID', 'Sales Date', 'Sales Volume', 'Sales Value'.",
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title": `Ensure "Sales Volume" & "Sales Value" monthly drift is observed within a certain range.`,
    Description: `Ensure "Sales Volume" & "Sales Value" monthly drift is observed within a certain range.`,
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title": `Ensure 'Sales Date' is within the expected range (e.g., not in the future).`,
    Description: `Ensure 'Sales Date' is within the expected range (e.g., not in the future).`,
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title": "Ensure 'Sales Volume' and 'Sales Value' are non-negative.",
    Description: "Ensure 'Sales Volume' and 'Sales Value' are non-negative.",
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title": "Ensure 'Promo Applied' values are either 'Yes' or 'No'.",
    Description: "Ensure 'Promo Applied' values are either 'Yes' or 'No'.",
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title":
      "Ensure 'Sales Date' follows the standard date format (e.g., YYYY-MM-DD).",
    Description:
      "Ensure 'Sales Date' follows the standard date format (e.g., YYYY-MM-DD).",
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
  {
    "Rule Title":
      "Ensure no redundant data entries (e.g., duplicate rows) in 'Product ID', 'Sales Date', 'Customer ID'.",
    Description: `Ensure no redundant data entries (e.g., duplicate rows) in 'Product ID', 'Sales Date', 'Customer ID'.`,
    Implementation: "",
    Columns_to_apply: "",
    Conditions: "None of the specified columns should have null values.",
  },
]

export const sampleRules = {
  Gen_AI_Rules: [
    {
      "Rule Title": "Mandatory Fields Completeness",
      Description:
        "Ensure that critical columns such as `KUNNR` (Customer ID) and `KLABC_DESC` (Customer Classification Description) are not null.",
      Implementation: "Check for null values in critical columns.",
      Columns_to_apply: "`KUNNR`, `KLABC_DESC`",
      Conditions: "None of the specified columns should have null values.",
    },
    {
      "Rule Title": "Data Consistency for Descriptive Fields",
      Description:
        'Ensure that descriptive fields do not contain placeholder values like "x".',
      Implementation: "Check for placeholder values in descriptive columns.",
      Columns_to_apply:
        "`ZZUNNEG_DESC`, `ZZSUBUNNEG`, `ZTPOCANAL_DESC`, `ZGPOCANAL_DESC`, `ZZCANAL_DESC`, `HKUNNR_DESC`, `KATR5_DESC`, `BZIRK_DESC`, `KVGR3_DESC`, `KDGRP_DESC`",
      Conditions:
        'None of the specified columns should contain the placeholder value "x".',
    },
    {
      "Rule Title": "Valid Range for Channel Percentage",
      Description:
        "Ensure that the `ZTPOCANAL` (Channel Percentage) values are within a valid range (0-100).",
      Implementation:
        "Validate the range of numeric values in the specified column.",
      Columns_to_apply: "`ZTPOCANAL`",
      Conditions: "Values should be between 0 and 100.",
    },
  ],
  Existing_Rules: ["'KUNNR' values to null", "'KUNNR' values unique"],
}
export const sampleRawData: any[] = [
  {
    table_name: "financial",
    total_number_of_column: 17,
    average_count_of_rows: 84260,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "weather",
    total_number_of_column: 14,
    average_count_of_rows: 37224,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "inflation",
    total_number_of_column: 6,
    average_count_of_rows: 351847443,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "promo",
    total_number_of_column: 7,
    average_count_of_rows: 10061,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "product",
    total_number_of_column: 23,
    average_count_of_rows: 1791,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "customer",
    total_number_of_column: 26,
    average_count_of_rows: 1181592,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "sellin",
    total_number_of_column: 14,
    average_count_of_rows: 351847443,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "calendar",
    total_number_of_column: 5,
    average_count_of_rows: 5114,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "ml_mapping",
    total_number_of_column: 2,
    average_count_of_rows: 77,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
]

export const sampleRulePipelineStatus = {
  data: [
    {
      PIPELINE_RUN_ID: "eace31f7-8927-11ef-9fa0-902e1695c5a1",
      TABLE: "sellin",
      RULE_TITLE: "Logical Consistency for Cost Units",
      RULE_DESCRIPTION:
        "Ensure that the `CU` (cost unit) is greater than or equal to both `CF` (cost factor) and `CFS` (cost factor standardized) to maintain logical consistency in cost calculations.",
      RULE_COLUMNS_TO_APPLY: "CU, CF, CFS",
      SQL_QUERY:
        "SELECT\n    'CU' AS Column,\n    'CU must be greater than or equal to CF' AS Error_Description,\n    COUNT(*) AS Violation_Count\nFROM\n    sellin_bs\nWHERE\n    CU < CF\n\nUNION ALL\n\nSELECT\n    'CU' AS Column,\n    'CU must be greater than or equal to CFS' AS Error_Description,\n    COUNT(*) AS Violation_Count\nFROM\n    sellin_bs\nWHERE\n    CU < CFS;",
      PROGRESS: "Completed",
      TYPE: "GENAI",
      SQL_EXECUTION_STATUS: "COMPLETED",
      RESULT: "",
    },
  ],
}

export const sampleRawData2: IRawDataObject[] = [
  {
    table_name: "Promo Header",
    total_number_of_column: 17,
    average_count_of_rows: 84260,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "Sales",
    total_number_of_column: 14,
    average_count_of_rows: 37224,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "Financial",
    total_number_of_column: 6,
    average_count_of_rows: 351847443,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "Promo",
    total_number_of_column: 7,
    average_count_of_rows: 10061,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "Marketing",
    total_number_of_column: 23,
    average_count_of_rows: 1791,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
  {
    table_name: "Operations",
    total_number_of_column: 26,
    average_count_of_rows: 1181592,
    quality_check: {
      schema_check: true,
      drift_check: true,
      data_check: true,
    },
  },
]

export const sampleExistingRules: IExistingRules[] = [
  {
    table_name: "sales",
    existing_rules:
      "Ensure that no special characters are present in 'Product Description' column.",
    condition: 0,
  },
  {
    table_name: "sales",
    existing_rules: "Ensure that Discount Percentage is between 0 and 100.",
    condition: 0,
  },
  {
    table_name: "sales",
    existing_rules: "Ensure missing values are filled with nearest certainty.",
    condition: 0,
  },
  {
    table_name: "sales",
    existing_rules: "Ensure SKU sales value meets 90% historical conformity.",
    condition: 0,
  },
  {
    table_name: "sales",
    existing_rules: "Ensure 'Sales Volume' and 'Sales value' are non-negative.",
    condition: 0,
  },
]

export const sampleOverViewData: IRulePipelineStatus[] = [
  {
    PIPELINE_RUN_ID: "xyz",
    TABLE: "Data Quality",
    RULE_TITLE: "Ensure that Discount Percentage is between 0 and 100.",
    RULE_DESCRIPTION: "Ensure that Discount Percentage is between 0 and 100.",
    SQL_EXECUTION_STATUS: "COMPLETED",
    PROGRESS: "Completed",
    RULE_COLUMNS_TO_APPLY: "Product Description",
    TYPE: "",
    SQL_QUERY: "",
    RESULT: "",
  },
  {
    PIPELINE_RUN_ID: "xyz",
    TABLE: "Data Quality",
    RULE_TITLE: "Ensure that 'Product ID' is unique across the dataset.",
    RULE_DESCRIPTION: "Ensure that 'Product ID' is unique across the dataset.",
    SQL_EXECUTION_STATUS: "PENDING",
    PROGRESS: "In Progress",
    RULE_COLUMNS_TO_APPLY: "Discount Percentage",
    TYPE: "",
    SQL_QUERY: "",
    RESULT: "",
  },
  {
    PIPELINE_RUN_ID: "xyz",
    TABLE: "Business Quality",
    RULE_TITLE: `New launch in "Sparkling" category post Jun 2024 and not before that`,
    RULE_DESCRIPTION: `New launch in "Sparkling" category post Jun 2024 and not before that`,
    SQL_EXECUTION_STATUS: "PENDING",
    PROGRESS: "In Progress",
    RULE_COLUMNS_TO_APPLY: "Missing Values",
    TYPE: "",
    SQL_QUERY: "",
    RESULT: "",
  },
  {
    PIPELINE_RUN_ID: "xyz",
    TABLE: "Business Quality",
    RULE_TITLE:
      "Distributor sales conformity of 84% compared to Retailer sales",
    RULE_DESCRIPTION:
      "Distributor sales conformity of 84% compared to Retailer sales",
    SQL_EXECUTION_STATUS: "COMPLETED",
    PROGRESS: "Completed",
    RULE_COLUMNS_TO_APPLY: "SKU Sales Value",
    TYPE: "",
    SQL_QUERY: "",
    RESULT: "",
  },
  {
    PIPELINE_RUN_ID: "xyz",
    TABLE: "Data Quality",
    RULE_TITLE: `Ensure "Sales Volume" & "Sales Value" monthly drift is observed within a certain range.`,
    RULE_DESCRIPTION: `Ensure "Sales Volume" & "Sales Value" monthly drift is observed within a certain range.`,
    SQL_EXECUTION_STATUS: "PENDING",
    PROGRESS: "Not Started",
    RULE_COLUMNS_TO_APPLY: "Sales Volume, Sales Value",
    TYPE: "",
    SQL_QUERY: "",
    RESULT: "",
  },
]

export const sampleOverViewData2: IRulePipelineStatus[] = [
  {
    PIPELINE_RUN_ID: "",
    TABLE: "Data Quality",
    RULE_TITLE:
      "Ensure that no special characters are present in 'Product Description' column.",
    RULE_DESCRIPTION:
      "Ensure that no special characters are present in 'Product Description' column.",
    SQL_EXECUTION_STATUS: "Completed",
    PROGRESS: "Completed",
    RULE_COLUMNS_TO_APPLY: "Product Description",
    TYPE: "",
    SQL_QUERY: "",
    RESULT: "",
  },
  {
    PIPELINE_RUN_ID: "",
    TABLE: "Data Quality",
    RULE_TITLE: "Ensure that Discount Percentage is between 0 and 100.",
    RULE_DESCRIPTION: "Ensure that Discount Percentage is between 0 and 100.",
    SQL_EXECUTION_STATUS: "In Progress",
    PROGRESS: "In Progress",
    RULE_COLUMNS_TO_APPLY: "",
    TYPE: "",
    SQL_QUERY: "",
    RESULT: "",
  },
  {
    PIPELINE_RUN_ID: "",
    TABLE: "Business Quality",
    RULE_TITLE: "Ensure missing values are filled with nearest certainty.",
    RULE_DESCRIPTION:
      "Ensure missing values are filled with nearest certainty.",
    SQL_EXECUTION_STATUS: "In Progress",
    PROGRESS: "In Progress",
    RULE_COLUMNS_TO_APPLY: "",
    TYPE: "",
    SQL_QUERY: "",
    RESULT: "",
  },
  {
    PIPELINE_RUN_ID: "",
    TABLE: "Business Quality",
    RULE_TITLE: "Ensure SKU sales value meets 90% historical conformity.",
    RULE_DESCRIPTION: "Ensure SKU sales value meets 90% historical conformity.",
    SQL_EXECUTION_STATUS: "Completed",
    PROGRESS: "Completed",
    RULE_COLUMNS_TO_APPLY: "",
    TYPE: "",
    SQL_QUERY: "",
    RESULT: "",
  },
  {
    PIPELINE_RUN_ID: "",
    TABLE: "Data Quality",
    RULE_TITLE: "Ensure 'Sales Volume' and 'Sales value' are non-negative.",
    RULE_DESCRIPTION:
      "Ensure 'Sales Volume' and 'Sales value' are non-negative.",
    SQL_EXECUTION_STATUS: "Not Started",
    PROGRESS: "Not Started",
    RULE_COLUMNS_TO_APPLY: "",
    TYPE: "",
    SQL_QUERY: "",
    RESULT: "",
  },
]
